const NOTES_BASE_URL =
  import.meta.env.VITE_GO_API_URL || 'http://localhost:8081'

export interface InvoiceNote {
  id: string
  invoice_id: string
  body: string
  author_email?: string | null
  created_at: string
  updated_at: string
}

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('access_token')
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

async function notesFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${NOTES_BASE_URL}${path}`, {
    ...options,
    headers: { ...authHeaders(), ...options?.headers },
  })
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText)
    throw new Error(`Notes API ${res.status}: ${text}`)
  }
  if (res.status === 204) return undefined as T
  return res.json()
}

export function listInvoiceNotes(invoiceId: string): Promise<InvoiceNote[]> {
  return notesFetch<InvoiceNote[]>(`/api/v1/invoices/${invoiceId}/notes`)
}

export function createInvoiceNote(
  invoiceId: string,
  body: string
): Promise<InvoiceNote> {
  return notesFetch<InvoiceNote>(`/api/v1/invoices/${invoiceId}/notes`, {
    method: 'POST',
    body: JSON.stringify({ body }),
  })
}

export function updateInvoiceNote(
  noteId: string,
  body: string
): Promise<InvoiceNote> {
  return notesFetch<InvoiceNote>(`/api/v1/invoice-notes/${noteId}`, {
    method: 'PATCH',
    body: JSON.stringify({ body }),
  })
}

export function deleteInvoiceNote(noteId: string): Promise<void> {
  return notesFetch<void>(`/api/v1/invoice-notes/${noteId}`, {
    method: 'DELETE',
  })
}
